import { PlusOutlined } from '@ant-design/icons';
import { Dropdown, Row, Tooltip } from 'antd';
import { ColumnsType } from 'antd/es/table';
import React, { useEffect, useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import ModalConfirm from 'components/commons/modalConfirm';
import { WrapperActionTable } from 'modules/role/page/style';
import { actionsType } from 'components/layouts/redux/leftMenu';
import { ActionType } from 'helper/constants';
import CTable from 'components/commons/Table';
import CustomSearch from 'components/commons/Search';
import CButton, { TypeCustom, TypeSizeCustom } from 'components/commons/Button';
import { ReactComponent as IconMore } from 'assets/imgs/IconMore.svg';
import { MenuProps } from 'rc-menu';
import { RowHeader, Text, WrapperButton } from 'components/commons/Template/style';
import { CReloadButton } from 'components/commons/ReloadButton';
import { studentManagerSelector } from '../selector';
import AddEditViewStudent from './AddEditViewStudent';
import {
  deleteStudent,
  getDetailStudent,
  getListCourses,
  getListStudent,
  getListStudentSuccess,
  setParams,
  setQsValue,
  setShowModal,
  setTypeModal,
} from '../redux';
import { typeLanguageSelector } from '../../../languages/selectors';
import { allParamSelector } from '../../auth/selectors';
import { ParamItem } from '../../auth/services/types';

interface DataType {
  key: React.Key;
  name: string;
  code: string;
  status: string;
}
const Grid = () => {
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([]);
  const { showModal, dataGrid, params, loadingTable, qsValue } = useSelector(studentManagerSelector);
  const langType = useSelector(typeLanguageSelector);
  const allParams = useSelector(allParamSelector);

  const onSelectChange = (newSelectedRowKeys: React.Key[]) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const dispatch = useDispatch();
  const intl = useIntl();
  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
  };
  const renderMenuItemsMore = (record: DataType, index: number): MenuProps['items'] => {
    const menuItem = [
      {
        key: actionsType.UPDATE,
        label: (
          <Text onClick={() => handleEditStudent(record)}>
            <FormattedMessage id={'common.edit'} />
          </Text>
        ),
      },
    ];
    if (!dataGrid.content[index]?.courseStarted) {
      menuItem.push({
        key: actionsType.DELETE,
        label: (
          <Text type="danger" onClick={() => handleDeleteStudent(record)}>
            <FormattedMessage id={'common.delete'} />
          </Text>
        ),
      });
    }
    return menuItem;
  };
  const columns: ColumnsType<DataType> = [
    {
      title: 'STT',
      align: 'left',
      width: 80,
      fixed: 'left',
      render(value, record, index) {
        return <Text>{index + 1 + params.page * params.size}</Text>;
      },
    },
    {
      title: intl.formatMessage({ id: 'common.name' }),
      dataIndex: 'fullName',
      width: 150,
      align: 'left',
      render(value) {
        return (
          <Tooltip title={value} placement="topLeft">
            <Text>{value}</Text>
          </Tooltip>
        );
      },
    },
    {
      title: intl.formatMessage({ id: 'student.idCard' }),
      dataIndex: 'citizenIdCardNo',
      width: 150,
      align: 'left',
      render(value) {
        return (
          <Tooltip title={value} placement="topLeft">
            <Text>{value}</Text>
          </Tooltip>
        );
      },
    },
    {
      title: intl.formatMessage({ id: 'student.typesOfTraining' }),
      dataIndex: 'trainingType',
      width: 150,
      align: 'left',
      render(value) {
        return (
          <Tooltip
            title={allParams?.TRAINING_TYPE?.find((item: ParamItem) => item.value === value.toString())?.label || ''}
            placement="topLeft"
          >
            <Text>{allParams?.TRAINING_TYPE?.find((item: ParamItem) => item.value === value.toString())?.label || ''}</Text>
          </Tooltip>
        );
      },
    },
    {
      title: intl.formatMessage({ id: 'student.courseCode' }),
      dataIndex: 'courses',
      width: 150,
      align: 'left',
      render(value) {
        return value.map((item: any) => {
          return (
            <Tooltip title={item.code} placement="topLeft">
              <Text>{item.code}</Text>
            </Tooltip>
          );
        });
      },
    },
    {
      title: intl.formatMessage({ id: 'student.trainingClass' }),
      dataIndex: 'courses',
      width: 150,
      align: 'left',
      render(value) {
        return value.map((item: any) => {
          return (
            <Tooltip title={item.licenseClass} placement="topLeft">
              <Text>{item.licenseClass}</Text>
            </Tooltip>
          );
        });
      },
    },
    {
      title: intl.formatMessage({ id: 'student.phoneNumber' }),
      dataIndex: 'phoneNo',
      width: 150,
      align: 'left',
      render(value) {
        return (
          <Tooltip title={value} placement="topLeft">
            <Text>{value}</Text>
          </Tooltip>
        );
      },
    },
    {
      title: intl.formatMessage({ id: 'student.email' }),
      dataIndex: 'email',
      width: 150,
      align: 'left',
      render(value) {
        return (
          <Tooltip title={value} placement="topLeft">
            <Text>{value}</Text>
          </Tooltip>
        );
      },
    },
    {
      title: intl.formatMessage({ id: 'common.action' }),
      align: 'center',
      fixed: 'right',
      width: 150,
      render(value, record, index) {
        return (
          <WrapperActionTable>
            <CButton typeCustom={TypeCustom.Action} onClick={() => handleViewStudent(record)}>
              {<FormattedMessage id={'student.detail'} />}
            </CButton>
            <Dropdown menu={{ items: renderMenuItemsMore(record, index) }} placement="bottomCenter" trigger={['click']}>
              <IconMore className="iconMore" />
            </Dropdown>
          </WrapperActionTable>
        );
      },
    },
  ];

  const handleSetQsValue = (value: string) => {
    dispatch(setQsValue(value));
  };

  const handleSetTypeModal = (value: string) => {
    dispatch(setTypeModal(value));
  };

  const handleAddStudent = () => {
    handleSetTypeModal(ActionType.ADD);
    dispatch(setShowModal(true));
  };

  const handleViewStudent = (itemEdit: any) => {
    handleSetTypeModal(ActionType.VIEW);
    dispatch(getDetailStudent(itemEdit.id));
  };

  const handleEditStudent = (itemEdit: any) => {
    handleSetTypeModal(ActionType.EDIT);
    dispatch(getDetailStudent(itemEdit.id));
  };

  const handleDeleteStudent = (itemEdit: any) => {
    if (itemEdit?.id) {
      ModalConfirm({
        title: 'common.confirmDelete',
        message: 'common.relatedDataDeleted',
        handleConfirm: () => {
          dispatch(deleteStudent([itemEdit?.id]));
        },
      });
    }
  };

  const handleDeleteMultiStudent = () => {
    if (selectedRowKeys) {
      ModalConfirm({
        title: 'common.confirmDelete',
        message: 'common.relatedDataDeleted',
        handleConfirm: () => {
          dispatch(deleteStudent(selectedRowKeys));
        },
      });
    }
  };

  const changeHeightTable = () => {
    const heightFilter = document.getElementById('filterStudentsManager')?.offsetHeight;
    const heightWrapper = document.getElementById('wrapperStudentsManager')?.offsetHeight;

    return (heightWrapper ?? 0) - (heightFilter ? heightFilter + 18 : 0) - 163;
  };

  const handleQuickSearch = (value: string) => {
    dispatch(
      setParams({
        ...params,
        page: 0,
        q: value,
      })
    );
  };

  const handleRefresh = () => {
    handleSetQsValue('');
    dispatch(setParams({ page: 0, size: 10, q: '' }));
  };

  const handleChangeTable = (pagination: any) => {
    dispatch(
      setParams({
        ...params,
        page: pagination.current - 1,
        size: pagination.pageSize,
      })
    );
  };

  useEffect(() => {
    dispatch(getListStudent(params));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [params, langType]);

  useEffect(() => {
    dispatch(getListCourses());
    return () => {
      dispatch(getListStudentSuccess([]));
      dispatch(setParams({ page: 0, size: 10, q: '' }));
      handleSetQsValue('');
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div>
      <RowHeader>
        <WrapperButton>
          <CustomSearch
            tooltip={intl.formatMessage({ id: 'student.tooltipQS' })}
            onSearch={handleQuickSearch}
            value={qsValue}
            setValue={handleSetQsValue}
          />
          <CReloadButton onClick={handleRefresh} />
        </WrapperButton>
        <WrapperButton>
          <CButton sizeCustom={TypeSizeCustom.Medium} onClick={handleDeleteMultiStudent} disabled={selectedRowKeys.length === 0}>
            <FormattedMessage id="common.delete" />
          </CButton>
          <CButton typeCustom={TypeCustom.Primary} sizeCustom={TypeSizeCustom.Medium} icon={<PlusOutlined />} onClick={handleAddStudent}>
            <FormattedMessage id="common.add" />
          </CButton>
        </WrapperButton>
      </RowHeader>
      <Row>
        <CTable
          rowSelection={rowSelection}
          rowKey={'id'}
          columns={columns}
          style={{ width: '100%' }}
          dataSource={dataGrid.content}
          loading={loadingTable}
          scroll={{ y: changeHeightTable() }}
          pagination={{
            showSizeChanger: true,
            pageSizeOptions: [10, 20, 30],
            current: params.page + 1,
            pageSize: params.size,
            size: 'small',
            total: dataGrid?.totalElements,
            showQuickJumper: true,
            showTotal: TotalMessage,
            locale: { jump_to: intl.formatMessage({ id: 'common.jump_to' }), page: '' },
          }}
          onChange={handleChangeTable}
        />
      </Row>
      {showModal && <AddEditViewStudent />}
    </div>
  );
};

const TotalMessage = (total: number) => {
  return (
    <>
      <FormattedMessage id="common.total" />
      {' ' + total + ' '}
      <FormattedMessage id="common.item" />
    </>
  );
};

export default Grid;
